import { ImportPortefeuille } from "./../../../models/ImportPortefeuille";
import { FondsPropresService } from "../../../services/fonds-propres.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { FileInput } from "ngx-material-file-input";

@Component({
  selector: "app-add-item-modal",
  templateUrl: "./add-item-modal.component.html",
  styleUrls: ["./add-item-modal.component.scss"],
})
export class AddItemModalComponent implements OnInit {
  form: FormGroup;
  pressButton: Boolean = false;

  //From row parameter
  importPortefeuille: ImportPortefeuille;
  title: string;
  loading = false;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private shared: FondsPropresService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.form = this.createForm(this.importPortefeuille);
  }

  createForm(data: any) {
    if (data) {
      return this.fb.group({
        id: [data ? data.id : ""],
        libelle: [
          data ? data.libelle : "",
          Validators.compose([Validators.required]),
        ],
        description: [data ? data.description : ""],
        fichier: [data ? data.fichier : null],
        fichierGarantie: [data ? data.fichierGarantie : null],
      });
    } else {
      return this.fb.group({
        id: [data ? data.id : ""],
        libelle: [
          data ? data.libelle : "",
          Validators.compose([Validators.required]),
        ],
        description: [data ? data.description : ""],
        fichier: [
          data ? data.fichier : null,
          Validators.compose([Validators.required]),
        ],
        fichierGarantie: [data ? data.fichierGarantie : null],
      });
    }
  }

  onSubmit() {
    this.submitted = true;
    // reset alerts on submit
    //this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;
    if (!this.importPortefeuille) {
      this.createData();
    } else {
      this.updateData();
    }
  }

  createData() {
    var formData = new FormData();
    const file_fichier = this.form.value.fichier;
    const fichier = file_fichier.files[0]; // in case user didn't selected multiple files

    const file_fichierGarantie = this.form.value.fichierGarantie;
    const fichierGarantie = file_fichierGarantie
      ? file_fichierGarantie.files[0]
      : null;

    formData.append("fichier", fichier);
    formData.append("fichierGarantie", fichierGarantie);
    formData.append("libelle", this.form.value.libelle);
    formData.append("description", this.form.value.description);
    formData.forEach(function (value, key) {
      console.log(key, value);
    });
    this.shared.saveDatasAndFileImportation(formData).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }

  updateData() {
    var formData = new FormData();
    const file_fichier = this.form.value.fichier;
    const fichier = file_fichier ? file_fichier.files[0] : null;

    const file_fichierGarantie = this.form.value.fichierGarantie;
    const fichierGarantie = file_fichierGarantie
      ? file_fichierGarantie.files[0]
      : null;

    formData.append("fichier", fichier);
    formData.append("fichierGarantie", fichierGarantie);
    formData.append("libelle", this.form.value.libelle);
    formData.append("description", this.form.value.description);
    formData.append("id", this.importPortefeuille.id.toString());
    formData.forEach(function (value, key) {
      console.log(key, value);
    });
    this.shared.updateDatasAndFileImportation(formData).subscribe(
      (data) => {
        this.activeModal.close();
      },
      (error) => {
        console.log(error);
        alert("Erreur :" + error);
      },
      () => {
        //redirectTo
        //window.location.reload();
        //this.tabGroup.selectedIndex = 1;
      }
    );
  }

  getFile(e) {
    let extensionAllowed = { xlsx: true, xls: true };

    var nam = e.target.files[0].name.split(".").pop().toLowerCase();
    if (!extensionAllowed[nam]) {
      alert(
        "SVP entrez un fichier au format excel " +
          Object.keys(extensionAllowed) +
          "."
      );
      this.form.controls["fichier"].setValue(null, { emitEvent: false });
      return;
    }

    //this.form.controls["fichier"].setValue(e.target.files[0]);
  }

  getFileGarantie(e) {
    let extensionAllowed = { xlsx: true, xls: true };

    var nam = e.target.files[0].name.split(".").pop();
    if (!extensionAllowed[nam]) {
      alert(
        "SVP entrez un fichier au format excel " +
          Object.keys(extensionAllowed) +
          "."
      );
      this.form.controls["fichierGarantie"].setValue(null, {
        emitEvent: false,
      });
      return;
    }

    //this.form.controls["fichier"].setValue(e.target.files[0]);
  }
}
